import { useEffect, useState } from 'react';
import { useSEO, generateOrganizationSchema, generateProductSchema, generateFAQSchema } from '../../utils/seo';
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import ProblemSection from './components/ProblemSection';
import StatsCounter from './components/StatsCounter';
import TrustedBySection from './components/TrustedBySection';
import SolutionSection from './components/SolutionSection';
import DemoVideoSection from './components/DemoVideoSection';
import BenefitsSection from './components/BenefitsSection';
import CompetitorComparisonSection from './components/CompetitorComparisonSection';
import HowItWorksSection from './components/HowItWorksSection';
import PricingSection from './components/PricingSection';
import ClientTestimonialsSection from './components/ClientTestimonialsSection';
import VideoTestimonialsSection from './components/VideoTestimonialsSection';
import GuaranteeSection from './components/GuaranteeSection';
import FAQSection from './components/FAQSection';
import TestimonialsSection from './components/TestimonialsSection';
import FinalCTASection from './components/FinalCTASection';
import Footer from './components/Footer';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  // SEO Configuration
  useSEO({
    title: 'NeuroAgents Global AI - Automação de Atendimento por IA 24h no WhatsApp',
    description: 'Automatize seu atendimento no WhatsApp com IA baseada em ChatGPT. Sistema de automação de atendimento e follow-up 24/7 para eliminar perda de clientes por demora ou esquecimento. CRM integrado, disparos em massa e dashboard completo.',
    keywords: 'automação atendimento whatsapp, inteligência artificial atendimento, chatbot whatsapp business, CRM automático, atendimento 24h, follow-up automático, IA conversacional',
    canonical: '/',
    type: 'website',
    jsonLd: {
      '@context': 'https://schema.org',
      '@graph': [
        generateOrganizationSchema(),
        generateProductSchema({
          name: 'NeuroAgents Plano Start',
          description: 'Agente de IA para WhatsApp com atendimento automático 24/7, follow-up automático e CRM interno',
          price: '197',
        }),
        generateProductSchema({
          name: 'NeuroAgents Plano Scale',
          description: 'Plano completo com integração Instagram, Facebook Messenger, disparos em massa, email marketing e CRM avançado',
          price: '297',
        }),
        generateFAQSchema([
          {
            question: 'O que é a NeuroAgents?',
            answer: 'A NeuroAgents Global AI é um sistema de automação de atendimento e follow-up por Inteligência Artificial, implementado diretamente nos canais de comunicação do cliente, principalmente WhatsApp. É um sistema de atendimento automatizado com IA baseada em ChatGPT, ajustada ao negócio do cliente.',
          },
          {
            question: 'Quanto custa a NeuroAgents?',
            answer: 'Oferecemos dois planos: Plano Start por R$ 197/mês com agente de IA para WhatsApp, atendimento e follow-up automático, CRM e dashboard. Plano Scale por R$ 297/mês com tudo do Start mais integração com Instagram e Facebook, disparos em massa, email marketing e CRM avançado.',
          },
          {
            question: 'Como funciona a implementação?',
            answer: 'Após a compra, você envia informações básicas do negócio (nicho, serviços, tom de voz). A Neuro configura o agente de IA e implanta no WhatsApp. A automação começa a funcionar 24/7. A implantação pode ser feita com acompanhamento do CEO Rafael F. Silva.',
          },
          {
            question: 'Qual a garantia oferecida?',
            answer: 'Oferecemos 7 dias de garantia legal. Se você não economizar pelo menos 5 horas semanais de atendimento manual após 30 dias, pode solicitar devolução dentro do prazo legal.',
          },
          {
            question: 'Para quem é indicado?',
            answer: 'Para empreendedores que recebem volume alto de mensagens, perdem vendas por demora na resposta, esquecem follow-ups, estão sobrecarregados ou querem escalar atendimento sem contratar equipe. Ideal para barbearias, clínicas, imobiliárias, concessionárias, academias e prestadores de serviço.',
          },
        ]),
      ],
    },
  });

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white font-sans">
      <Navbar scrolled={scrolled} />
      <HeroSection />
      <ProblemSection />
      <StatsCounter />
      <TrustedBySection />
      <SolutionSection />
      <DemoVideoSection />
      <BenefitsSection />
      <CompetitorComparisonSection />
      <HowItWorksSection />
      <PricingSection />
      <ClientTestimonialsSection />
      <VideoTestimonialsSection />
      <GuaranteeSection />
      <FAQSection />
      <TestimonialsSection />
      <FinalCTASection />
      <Footer />
    </div>
  );
}
